import { getToolLabel, ToolPart } from "../Tool/helpers";

export const getHeaderLabel = (lastTool: ToolPart | undefined, isLive: boolean) => {
  if (lastTool) {
    return getToolLabel(lastTool);
  }

  return isLive ? "Thinking" : "Thought";
};
